module.exports = __webpack_public_path__ + "img/labmemtest_text_btn02_en.0943842c.png";